<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="auto">
          <h6 class="m-0">Fotos do local <small>(opcional)</small></h6>
        </d-col>
      </d-row>
    </d-card-header>

     <d-card-body class="d-flex flex-column">
        <div class="d-flex flex-fill flex-column">
          <d-form-row>
            <!-- Installation Local -->
            <d-col cols="12" md="6" class="form-group">
              <label for="name">Local de instalação</label>
              <ul class="upload">
                <li v-for="(image, index) in model.files.installation_local" :key="index">
                  <step-upload-image
                    :image="image"
                    :index="index"
                    @update:image="updateImage"
                    file-type="installation_local"
                    @openLightbox="showLightBox(index, 'installation_local')"
                  />
                </li>
              </ul>
            </d-col>
            <!-- Access Local -->
            <d-col cols="12" md="6" class="form-group">
              <label for="name">Local de acesso</label>
              <ul class="upload">
                <li v-for="(image, index) in model.files.access_local" :key="index">
                  <step-upload-image
                    :image="image"
                    :index="index"
                    @update:image="updateImage"
                    file-type="access_local"
                    @openLightbox="showLightBox(index, 'access_local')"
                  />
                </li>
              </ul>
            </d-col>
          </d-form-row>
          <d-form-row>
            <!-- Medition Local -->
            <d-col cols="12" md="6" class="form-group">
              <label for="name">Medição do Local</label>
              <ul class="upload">
                <li v-for="(image, index) in model.files.medition_local" :key="index">
                  <step-upload-image
                    :image="image"
                    :index="index"
                    @update:image="updateImage"
                    file-type="medition_local"
                    @openLightbox="showLightBox(index, 'medition_local')"
                  />
                </li>
              </ul>
            </d-col>
            <!-- Plant Local -->
            <d-col cols="12" md="6" class="form-group">
              <label for="name">Planta do Local</label>
              <ul class="upload">
                <li v-for="(image, index) in model.files.plant_local" :key="index">
                  <step-upload-image
                    :image="image"
                    :index="index"
                    @update:image="updateImage"
                    file-type="plant_local"
                    @openLightbox="showLightBox(index, 'plant_local')"
                  />
                </li>
              </ul>
            </d-col>
          </d-form-row>
        </div>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button class="btn btn-success" @click="nextStep">Avançar</button>
        </d-col>
      </d-form-row>
    </d-card-body>
    <vue-easy-lightbox
      scrollDisabled
      :visible="visible"
      :imgs="lightboxImage"
      :index="index"
      :loop="true"
      @hide="handleHide"
    ></vue-easy-lightbox>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import VueEasyLightbox from 'vue-easy-lightbox';
import Datepicker from '_shared/Datepicker.vue';
import NoPermission from './NoPermission.vue';
import StepUploadImage from './StepUploadImage.vue';
import {
  MODEL,
  FILES,
  FILE,
  _LOAD_MODEL_,
  FILES_DEFAULT,
} from './QuotationModel';

export default {
  name: 'Step-files',
  data() {
    return {
      index: 0,
      visible: false,
      model: cloneDeep(MODEL),
      lightboxImage: null,
    };
  },
  components: {
    Datepicker,
    NoPermission,
    VueEasyLightbox,
    StepUploadImage,
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    nextStep() {
      this.$router.push({ name: 'admin-quotation-approved', params: { quotationId: this.model.id } });
    },
    updateImage({ image, index, type }) {
      this.model.files[type][index] = image;
      this.model.steps.step.picture.completed = true;
      this.$store.commit('setQuotation', this.model);
      Events.$emit(_LOAD_MODEL_, this.model);
      this.$forceUpdate();
    },
    fillDefaultFiles(type) {
      for (let index = this.model.files[type].length; index < 4; index += 1) {
        this.model.files[type].push(FILE);
      }
    },
    loadModel() {
      const { quotation } = this.$store.state.quotation;
      if (quotation) {
        this.model = quotation;
        this.loadDefaultFileTypes();
      }
    },
    showLightBox(index, type = 'installation_local') {
      this.visible = true;
      this.lightboxImage = this.model.files[type].filter(file => file.file).map(file => file.file.url);
      this.index = index;
    },
    loadDefaultFileTypes() {
      if (this.model.files) {
        Object.keys(FILES).forEach(fileKey => {
          if (!this.model.files[fileKey]) {
            this.model.files[fileKey] = cloneDeep(FILES_DEFAULT);
          }
          if (this.model.files[fileKey].length < 4) {
            this.fillDefaultFiles(fileKey);
          }
        });
      }
    },
    handleHide() {
      this.visible = false;
    },
  },
  mounted() {
    this.loadModel();
    Events.$on(_LOAD_MODEL_, quotation => {
      this.model = quotation;
      this.loadDefaultFileTypes();
    });
  },
};
</script>

<style lang="scss" scoped>
.upload {
  list-style: none;
  padding: 0;
  display: flex;
  gap: 16px;
}
</style>
